module.exports = __webpack_public_path__ + "img/quest_icon_0078_special4.ee1c7d4f.png";